// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .slide-top {
  animation: slide-in-blurred-top 2s cubic-bezier(0.23, 1, 0.32, 1) 0.1s both;
}
:host .slide1 {
  animation: slide-in-blurred-bottom 0.5s cubic-bezier(0.23, 1, 0.32, 1) both;
}
:host .slide2 {
  animation: slide-in-bottom 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
:host .slide3 {
  animation: slide-in-bottom 1.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
:host .logo {
  width: 200px;
  margin-top: 30px;
}
:host .logo img {
  width: 100%;
}
:host ion-card {
  padding-top: 10px;
}
:host ion-input {
  color: var(--ion-color-primary-contrast) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-login/custom-login.component.scss"],"names":[],"mappings":"AACE;EAEE,2EAAA;AAAJ;AAGE;EAEE,2EAAA;AADJ;AAIE;EAEE,yEAAA;AAFJ;AAKE;EAEE,yEAAA;AAHJ;AAME;EACE,YAAA;EACA,gBAAA;AAJJ;AAMI;EACE,WAAA;AAJN;AAQE;EACE,iBAAA;AANJ;AASE;EACE,mDAAA;AAPJ","sourcesContent":[":host {\n  .slide-top {\n    -webkit-animation: slide-in-blurred-top 2s cubic-bezier(0.230, 1.000, 0.320, 1.000) 0.1s both;\n    animation: slide-in-blurred-top 2s cubic-bezier(0.230, 1.000, 0.320, 1.000) 0.1s both;\n  }\n\n  .slide1 {\n    -webkit-animation: slide-in-blurred-bottom 0.5s cubic-bezier(0.230, 1.000, 0.320, 1.000) both;\n    animation: slide-in-blurred-bottom 0.5s cubic-bezier(0.230, 1.000, 0.320, 1.000) both;\n  }\n\n  .slide2 {\n    -webkit-animation: slide-in-bottom 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n    animation: slide-in-bottom 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n  }\n\n  .slide3 {\n    -webkit-animation: slide-in-bottom 1.1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n    animation: slide-in-bottom 1.1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n  }\n\n  .logo {\n    width: 200px;\n    margin-top: 30px;\n\n    img {\n      width: 100%;\n    }\n  }\n\n  ion-card {\n    padding-top: 10px;\n  }\n\n  ion-input {\n    color: var(--ion-color-primary-contrast) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
